const scan = {
    link: "http://weixin.qq.com/r/9yg4IGPEZj4ZrSdD933l",
    TransmissionLink: "http://parkinglot.scan.easthuaxin.com/weChat/userNoFollowToGetCoupon"
    // link: "http://parkinglot.scan.easthuaxin.com/weChat/userNoFollowToGetCoupon"
};
export default scan
